"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useSubscriptionModule = exports.subscriptionModuleContextDefaultValue = exports.subscriptionModuleContext = exports.SubscriptionModuleProvider = void 0;
var _react = require("react");
var _jsxRuntime = require("react/jsx-runtime");
const subscriptionModuleContextDefaultValue = exports.subscriptionModuleContextDefaultValue = {
  analyticsData: {
    formattedPrice: '',
    localName: ''
  },
  customerTypeId: 0,
  deliveryFrequencyOptions: [],
  isBrandPartner: false,
  itemCode: '',
  purchaseOptionCashback: null,
  recommendedFrequency: 0,
  subscribeOptionCashback: null
};
const subscriptionModuleContext = exports.subscriptionModuleContext = /*#__PURE__*/(0, _react.createContext)(subscriptionModuleContextDefaultValue);
const SubscriptionModuleProvider = ({
  value,
  children
}) => {
  const contextValue = (0, _react.useMemo)(() => ({
    ...value,
    isBrandPartner: value.customerTypeId === 1
  }), [value]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(subscriptionModuleContext.Provider, {
    value: contextValue,
    children: children
  });
};
exports.SubscriptionModuleProvider = SubscriptionModuleProvider;
const useSubscriptionModule = () => (0, _react.useContext)(subscriptionModuleContext);
exports.useSubscriptionModule = useSubscriptionModule;
//# sourceMappingURL=context.js.map